import axios from "axios";

import { BASE_URL } from "./apiBase";

export const getCart = async () => {
  const response = await axios.get(`${BASE_URL}/api/Cart`);
  return response.data;
};

export const saveCart = async (items) => {
  const response = await axios.put(`${BASE_URL}/api/Cart`, { items });
  return response.data;
};

export const clearCartRemote = async () => {
  await axios.delete(`${BASE_URL}/api/Cart`);
};
